<template>
  <div
    class="topBarContainer flexBetween"
    v-show="isSmartCityApp"
    :style="{
      backgroundColor: `rgba(255, 255, 255,${
        scrollTop ? scrollTop / (scrollTop + 20) : 0
      }`,
    }"
  >
    <div class="flexStart">
      <div class="backBtn flexColumnCenter" @click="back">
        <img src="../../assets/icon-back.png" alt="" />
      </div>
      <div class="pageTitle">{{ title }}</div>
    </div>
    <div class="tool-wrap">
      <i class="iconfont icon-xiaochengxufenxiang" @click="share"></i>
      <i class="line"></i>
      <i class="iconfont icon-xiaochengxu-guanbi" @click="goBack"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopBar",
  props: {
    title: String,
    backHome: Boolean,
    isIndex: Boolean,
    shareData: Object,
  },
  data() {
    return { isSmartCityApp: false, scrollTop: 0 };
  },
  components: {},
  methods: {
    back() {
      if (this.backHome) {
        this.$router.push("/home");
      } else if (this.isIndex) {
        SmartCity.goAbort();
        SmartCity.hideTopView({
          isShow: 1,
        });
      } else {
        this.$router.go(-1);
      }
    },
    jumpToDetail() {
      this.$router.push("./powerDetail");
    },
    goBack() {
      SmartCity.goBack();
    },
    share() {
      SmartCity.shareTo({
        ...this.shareData,
      });
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector(".topBarContainer").offsetTop;
      if (offsetTop !== null && scrollTop) {
        this.scrollTop = scrollTop;
        console.log("scrollTop" + scrollTop);
        // 通过opacity
        // let opacity = this.scrollTop / 140;
        // opacity = opacity > 1 ? 1 : opacity;
        // if (this.scrollTop > 20) {
        //   this.opacityStyle = { opacity };
        // } else {
        //   this.opacityStyle = { opacity: 0 };
        // }
      }
      if (scrollTop == 0) {
        this.scrollTop = 0;
      }
    },
  },
  watch: {},
  created() {
    this.isSmartCityApp = SmartCity.isSmartCityApp();
    SmartCity.hideTopView({
      isShow: 0,
    });
    if (process.env.NODE_ENV === "development") {
      this.isSmartCityApp = true;
    }

    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="less">
.noFixed {
  position: absolute !important;
  background: transparent !important;
  .pageTitle {
    color: #fff !important;
  }
}
.topBarContainer {
  width: calc(100%);
  height: 50px;
  padding: 60px 15px 20px;
  position: fixed;
  top: 0;
  background: transparent;
  // background: #fff;
  z-index: 99;
  // border-bottom: 1px solid #eaeaea;
}
.noBg {
  background: transparent;
  .pageTitle {
    color: #fff;
  }
}
.pageTitle {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-left: 10px;
}
.topTextBtn {
  font-size: 13px;
  font-weight: 400;
  color: #333333;
}
.backBtn {
  width: 8px;
  height: 15px;
  img {
    width: 100%;
  }
}
.noBottomLine {
  border-bottom: none;
}
.topFunBtn {
  font-size: 14px;
  font-weight: 500;
  color: #999999;
}
.tool-wrap {
  display: flex;
  align-items: center;
  padding: 0 14px;
  height: 28px;
  line-height: 28px;
  position: absolute;
  right: 20px;
  top: 42px;
  background: #ffffff66;
  color: #666;
  font-size: 16px;
  border-radius: 20px;
  text-align: center;

  z-index: 100;
  border: 1px solid #f2f2f2;

  .line {
    border-right: 1px solid #f2f2f2;
    height: 20px;
    margin: 2px 10px;
  }

  i:nth-child(1) {
    font-size: 20px;
  }
}

.tool-wrap-black {
  position: absolute;
  right: -10px;
  top: -15px;
  background: rgba(0, 0, 0, 0.4);

  color: #fff;
  font-size: 16px;
  border-radius: 20px;
  text-align: center;
  padding: 0 14px;
  height: 28px;
  line-height: 28px;
  z-index: 100;
  display: flex;
  align-items: center;

  .line {
    border-right: 1px solid #eee;
    height: 20px;
    margin: 2px 10px;
  }
  i:nth-child(1) {
    font-size: 20px;
  }
}
@font-face {
  font-family: "iconfont";
  /* Project id 3124047 */
  src: url("//at.alicdn.com/t/font_3124047_5t09q4mrxsw.woff2?t=1647597818102")
      format("woff2"),
    url("//at.alicdn.com/t/font_3124047_5t09q4mrxsw.woff?t=1647597818102")
      format("woff"),
    url("//at.alicdn.com/t/font_3124047_5t09q4mrxsw.ttf?t=1647597818102")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-xiaochengxufenxiang:before {
  content: "\e675";
}
.icon-xiaochengxu-guanbi:before {
  content: "\e68c";
}
.rightContainer {
  position: relative;
}
</style>
